import { RESTAURANT_CATEGORY } from 'constants/constants';

export const CHOWNOW_CATEGORIES_TO_ENABLE_INTEGRATION = [RESTAURANT_CATEGORY];
